import { z } from 'zod';

import { PasswordValidator } from '@/utils/password';
import {
  ERROR_FIELD_REQUIRED,
  ERROR_INVALID_EMAIL,
  ERROR_OTP_LENGTH,
  ERROR_PHONE_REQUIRED,
  ERROR_INVALID_PHONE,
  ERROR_CUSTOM_DISEASE_TOO_LONG,
} from '@/utils/messages';

// ─── Shared field schemas ─────────────────────────────────────────────────────

export const requiredString = z.string().trim().min(1, ERROR_FIELD_REQUIRED);

export const emailSchema = z.email(ERROR_INVALID_EMAIL);

export const passwordSchema = z.string().superRefine((val, ctx) => {
  const result = PasswordValidator.validatePasswordDetailed(val);
  if (!result.isValid) {
    ctx.addIssue({ code: 'custom' as const, message: result.message });
  }
});

export const otpSchema = z.string().length(6, ERROR_OTP_LENGTH);

export const phoneSchema = z
  .string()
  .trim()
  .min(1, ERROR_PHONE_REQUIRED)
  .regex(/^[+\d][\d\s\-().]{4,}$/, ERROR_INVALID_PHONE);

export const customDiseaseSchema = z.string().trim().max(500, ERROR_CUSTOM_DISEASE_TOO_LONG);
